import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import {
    submitRequestInvoice,
    SubmitRequestInvoiceApiParameter,
} from "@solveindustrial/Services/RequestInvoiceService";

type HandlerType = ApiHandler<SubmitRequestInvoiceApiParameter, any>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestInvoice: HandlerType = async props => {
    props.apiResult = await submitRequestInvoice(props.apiParameter);
};

export const chain = [PopulateApiParameter, RequestInvoice];

const requestInvoice = createHandlerChainRunner(chain, "RequestInvoice");
export default requestInvoice;
